import React from "react";
import * as aor from "react-admin";
import { withStyles } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import AddressLink from "../../components/AddressLink";

import {
    POLICY_CUSTOMERS,
    POLICY_NOTIFICATIONS
} from "../../common/rolesManagement";
import ExportButton from "../../components/ExportButton";
import { getPolicies } from "../../common/authClient";

const disabledStyles = {
    disabled: {
        backgroundColor: "black",
        labelColor: "red"
    }
};
const DisabledChipField = withStyles(disabledStyles)(
    ({ classes, ...props }) => (
        <aor.ChipField
            source="name"
            style={
                props.data.disabled
                    ? { backgroundColor: grey[100], color: grey[400] }
                    : {}
            }
            {...props}
        />
    )
);
DisabledChipField.defaultProps = aor.ChipField.defaultProps;

const CustomIterator = ({ ids, data, ...props }) => (
    <div>
        {data && ids && ids.length > 0
            ? ids.map(id => (
                  <aor.ReferenceField
                      record={data[id]}
                      {...props}
                      reference="companies"
                      source="company_id"
                  >
                      {data &&
                      data[id] &&
                      props.disabled === data[id].disabled ? (
                          <DisabledChipField data={data[id]} />
                      ) : (
                          <tr />
                      )}
                  </aor.ReferenceField>
              ))
            : []}
    </div>
);

CustomIterator.defaultProps = aor.SingleFieldList.defaultProps;

const Filter = props => (
    <aor.Filter {...props}>
        <aor.TextInput source="vatin" alwaysOn={true} />
        <aor.TextInput source="name" alwaysOn={true} />
        {props.permissions &&
            props.permissions.includes(POLICY_CUSTOMERS.SHOW_COMPANY) && (
                <aor.TextInput source="company_name" alwaysOn={true} />
            )}
        {props.permissions &&
            props.permissions.includes(POLICY_CUSTOMERS.SHOW_DISABLED) && (
                <aor.BooleanInput
                    source="deleted"
                    alwaysOn={true}
                    label="Disabilitati"
                >
                    {(state.disabled = props.filterValues.deleted)}
                </aor.BooleanInput>
            )}
    </aor.Filter>
);

const CustomersActions = ({ permissions, basePath, _ }) => (
    <aor.CardActions>
        {permissions && permissions.includes(POLICY_CUSTOMERS.CREATE) && (
            <span>
                <aor.CreateButton basePath={basePath} />
            </span>
        )}
        <span>
            {permissions && permissions.includes(POLICY_CUSTOMERS.EXPORT) && (
                <ExportButton />
            )}
        </span>
    </aor.CardActions>
);
const state = { disabled: false };
export default props => (
    <aor.List
        {...props}
        title="resources.customers.views.list.title"
        filters={<Filter permissions={getPolicies()} />}
        sort={{ field: "name", order: "ASC" }}
        bulkActionButtons={false}
        actions={<CustomersActions permissions={getPolicies()} />}
    >
        <aor.Datagrid>
            <aor.TextField source="vatin" />
            <aor.TextField source="name" />
            <AddressLink
                {...props}
                source="email"
                enabled={getPolicies().includes(
                    POLICY_NOTIFICATIONS.SEND_NOTIFICATIONS
                )}
            />
            <aor.NumberField
                source="total_active_installations"
                sortable={false}
            />
            <aor.NumberField
                source="total_licensed_installations"
                sortable={false}
            />
            {getPolicies() &&
                getPolicies().includes(POLICY_CUSTOMERS.SHOW_COMPANY) && (
                    <aor.ReferenceManyField
                        reference="customers-mappings"
                        target="customer_id"
                        sortable={false}
                        label="Aziende collegate"
                        sort={{ field: "name", order: "ASC" }}
                    >
                        <CustomIterator
                            disabled={
                                state.disabled === undefined
                                    ? false
                                    : state.disabled
                            }
                        />
                    </aor.ReferenceManyField>
                )}
            <aor.ShowButton />
            {getPolicies() &&
                getPolicies().includes(POLICY_CUSTOMERS.UPDATE) && (
                    <aor.EditButton />
                )}
        </aor.Datagrid>
    </aor.List>
);



// WEBPACK FOOTER //
// ./src/resources/Customers/List.js